import { ContactInfo, LiveCallLog } from 'store/types/lead'
import { AppBarCallStatus, DialerClientStatus, useDialerUIContext } from './DialerUIContext'

export const useDialerClientActions = () => {
  const { dispatch, showOutcomeForm } = useDialerUIContext()

  return {
    showRightPanel: (defaultContact?: ContactInfo) => dispatch({ type: 'SHOW_RIGHT_PANEL', defaultContact }),
    hideRightPanel: () => dispatch({ type: 'HIDE_RIGHT_PANEL' }),
    showAppBarStatus: (status: AppBarCallStatus) => dispatch({ type: 'SHOW_APPBAR_STATUS', status }),
    hideAppBarStatus: () => dispatch({ type: 'HIDE_APPBAR_STATUS' }),
    showOutcomeForm: (liveCallLog: LiveCallLog) => showOutcomeForm(liveCallLog),
    setIsCalling: (isCalling: boolean) => dispatch({ type: 'SET_IS_CALLING', isCalling }),
    setIsSubmmiting: (isSubmitting: boolean) => dispatch({ type: 'SET_IS_SUBMITTING', isSubmitting }),
    setIsDisable: (isDisable: boolean) => dispatch({ type: 'SET_IS_DISABLE', isDisable }),
    setDialerClientStatus: (dialerStatus: DialerClientStatus) => dispatch({ type: 'SET_DIALER_STATUS', dialerStatus }),
  }
}
